import {setScreen} from '../slices/tabSlice';
import {setLanguage} from '../slices/preferencesSlice';

export const actions = {
  setScreen,
  setLanguage,
};
